import { BaseEntity } from './base-entity';

export type IssueState =
    'DISABLED' |
    'ENABLED';

// TODO: update to the newest model from server
export class Issue implements BaseEntity {
    constructor(public id?: number,
                public name?: string,
                // TODO: To remove
                public description?: string,
                public priority?: number,
                public averageTime?: number,
                public queueId?: number,
                public state?: IssueState) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/issue.model.ts